import { gql, useMutation } from '@apollo/client';
import { GET_DPO_AUDIT_REPORT_HISTORY } from './useDpoAuditReportHistoryQuery';

const DELETE_DPO_AUDIT_REPORT_HISTORY = gql`
  mutation DeleteDpoAuditReportHistory($id: String!) {
    deleteDpoAuditReportHistory(id: $id)
  }
`;

export interface DeleteDpoAuditReportHistoryResult {
  deleteDpoAuditReportHistory: boolean;
}

export interface DeleteDpoAuditReportHistoryInput {
  id: string;
}

export function useDeleteDpoAuditReportHistoryMutation(companyId: string) {
  return useMutation<DeleteDpoAuditReportHistoryResult, DeleteDpoAuditReportHistoryInput>(
    DELETE_DPO_AUDIT_REPORT_HISTORY,
    {
      refetchQueries: [{ query: GET_DPO_AUDIT_REPORT_HISTORY, variables: { companyId } }],
    }
  );
}
